import { render, staticRenderFns } from "./changeRole.vue?vue&type=template&id=5d19db18&scoped=true"
import script from "./changeRole.vue?vue&type=script&lang=js"
export * from "./changeRole.vue?vue&type=script&lang=js"
import style0 from "./changeRole.vue?vue&type=style&index=0&id=5d19db18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d19db18",
  null
  
)

export default component.exports